var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "z-page",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { "margin-top": "20px" },
          attrs: { "separator-class": "el-icon-arrow-right" },
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v("首页"),
          ]),
          _c("el-breadcrumb-item", [_vm._v("修改包裹信息")]),
        ],
        1
      ),
      _c(
        "el-card",
        { staticStyle: { "margin-top": "20px" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 30, span: 24 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8, xs: 8, sm: 8, md: 8 } },
                [
                  _c("el-input", {
                    attrs: { clearable: true, placeholder: "包裹号" },
                    on: { blur: _vm.getPackage },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.getPackage.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.editForm.packageAttrNum,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "packageAttrNum", $$v)
                      },
                      expression: "editForm.packageAttrNum",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 30, span: 24 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6, xs: 6, sm: 6, md: 6 } },
                [
                  _c("el-row", { attrs: { span: 24 } }, [
                    _c(
                      "div",
                      { staticClass: "container info-card package-info" },
                      [
                        _c("div", { staticClass: "info-header" }, [
                          _c(
                            "svg",
                            {
                              staticClass: "icon",
                              attrs: { "aria-hidden": "true" },
                            },
                            [
                              _c("use", {
                                attrs: { "xlink:href": "#icon-icon_order" },
                              }),
                            ]
                          ),
                          _c("h1", { staticClass: "title" }, [
                            _vm._v("订单信息"),
                          ]),
                        ]),
                        _vm.showPackageInfo
                          ? _c("div", { staticClass: "info-body" }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c(
                                  "label",
                                  { staticClass: "info-item-label" },
                                  [_vm._v("用户编码")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "info-item-content user-code",
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.packageData.user_code)),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "info-item" }, [
                                _c(
                                  "label",
                                  { staticClass: "info-item-label" },
                                  [_vm._v("订单单号")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "info-item-content" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.packageData.package_num) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "info-item" }, [
                                _c(
                                  "label",
                                  { staticClass: "info-item-label" },
                                  [_vm._v("客户昵称")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "info-item-content" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.packageData.user_info.nickName ||
                                            "-"
                                        ) +
                                        " "
                                    ),
                                    _vm.packageData.is_packaging_service
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item icon-packing",
                                            attrs: {
                                              effect: "dark",
                                              content: "该用户需要收取打包费",
                                              placement: "right-start",
                                            },
                                          },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                staticClass: "icon",
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              },
                                              [
                                                _c("use", {
                                                  attrs: {
                                                    "xlink:href":
                                                      "#icon-receive",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "info-item" },
                                [
                                  _c(
                                    "label",
                                    { staticClass: "info-item-label" },
                                    [_vm._v("客户类型")]
                                  ),
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        size: "mini",
                                        type: _vm.formatUserRole(
                                          _vm.packageData.user_role
                                        ).tag_type,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatUserRole(
                                            _vm.packageData.user_role
                                          ).name
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "info-item" }, [
                                _c(
                                  "label",
                                  { staticClass: "info-item-label" },
                                  [_vm._v("微信头像")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "info-item-content" },
                                  [
                                    _vm.packageData.user_info.avatarUrl
                                      ? _c("img", {
                                          staticClass: "avatar",
                                          attrs: {
                                            src: _vm.packageData.user_info
                                              .avatarUrl,
                                          },
                                        })
                                      : _c("p", [_vm._v("-")]),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "info-item" }, [
                                _c(
                                  "label",
                                  { staticClass: "info-item-label" },
                                  [_vm._v("国内快递单号")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "info-item-content" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.packageData.logistics_code) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "info-item" }, [
                                _c(
                                  "label",
                                  { staticClass: "info-item-label" },
                                  [_vm._v("收件国家/地区")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "info-item-content receiver-country",
                                  },
                                  [
                                    _vm.getCountryIcon(_vm.packageData.country)
                                      ? _c("img", {
                                          staticClass: "country-icon",
                                          attrs: {
                                            src: _vm.getCountryIcon(
                                              _vm.packageData.country
                                            ),
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getCountryNameCn(
                                            _vm.packageData.country
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "info-item" }, [
                                _c(
                                  "label",
                                  { staticClass: "info-item-label" },
                                  [_vm._v("收件人信息")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "info-item-content receiver-info",
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.packageData.firstname) +
                                          " " +
                                          _vm._s(_vm.packageData.lastname) +
                                          " "
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(_vm.packageData.mobile || "-")
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.packageData.address1) +
                                          " " +
                                          _vm._s(_vm.packageData.address2) +
                                          "," +
                                          _vm._s(_vm.packageData.city) +
                                          "," +
                                          _vm._s(_vm.packageData.state) +
                                          " " +
                                          _vm._s(_vm.packageData.zipcode) +
                                          " "
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "info-item" }, [
                                _c(
                                  "label",
                                  { staticClass: "info-item-label" },
                                  [_vm._v("包裹保费")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "info-item-content" },
                                  [
                                    _vm._v(
                                      " ¥" +
                                        _vm._s(_vm.packageData.declare_amount) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "info-item" }, [
                                _c(
                                  "label",
                                  { staticClass: "info-item-label" },
                                  [_vm._v("客户下单线路")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "info-item-content" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.packageData.express_title || "-"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "info-item" }, [
                                _c(
                                  "label",
                                  { staticClass: "info-item-label" },
                                  [_vm._v("订单状态")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "info-item-content" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.packageData.status_label) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "info-item" }, [
                                _c(
                                  "label",
                                  { staticClass: "info-item-label" },
                                  [_vm._v("支付状态")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "info-item-content" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.packageData.status_pay_label
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "info-item" }, [
                                _c(
                                  "label",
                                  { staticClass: "info-item-label" },
                                  [_vm._v("下单时间")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "info-item-content" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("formatDate")(
                                            _vm.packageData.created
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 18, xs: 18, sm: 18, md: 18 } },
                [
                  _c("el-row", { attrs: { span: 24 } }, [
                    _c(
                      "div",
                      { staticClass: "container info-card package-info" },
                      [
                        _c("div", { staticClass: "info-header" }, [
                          _c(
                            "svg",
                            {
                              staticClass: "icon",
                              attrs: { "aria-hidden": "true" },
                            },
                            [
                              _c("use", {
                                attrs: { "xlink:href": "#icon-icon_order" },
                              }),
                            ]
                          ),
                          _c("h1", { staticClass: "title" }, [
                            _vm._v("所有包裹信息"),
                          ]),
                        ]),
                        _vm.showPackageInfo
                          ? _c("div", { staticClass: "info-body" }, [
                              _vm.orderMatched.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "info-item" },
                                    [
                                      _c(
                                        "el-table",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            data: _vm.orderMatched,
                                            "row-class-name":
                                              _vm.tableRowClassName,
                                          },
                                        },
                                        [
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "package_attr_num",
                                              label: "包裹号",
                                              "min-width": "180",
                                            },
                                          }),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "declare_amount",
                                              label: "状态",
                                              "min-width": "70",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c(
                                                        "el-tag",
                                                        {
                                                          attrs: {
                                                            size: "mini",
                                                            type:
                                                              scope.row
                                                                .status == 1
                                                                ? "success"
                                                                : "danger",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                scope.row
                                                                  .status == 1
                                                                  ? "已保存"
                                                                  : "未保存"
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              3893883352
                                            ),
                                          }),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "express_name",
                                              label: "线路",
                                              "min-width": "270",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          attrs: {
                                                            size: "mini",
                                                            filterable: "",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row
                                                                .express_id,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "express_id",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.express_id",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.expressList,
                                                          function (item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item.id,
                                                                attrs: {
                                                                  label: `[${item.id}] ${item.title} `,
                                                                  value:
                                                                    item.id,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              193890532
                                            ),
                                          }),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "rate_price",
                                              label: "价格",
                                              "min-width": "170",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("el-input", {
                                                        attrs: {
                                                          value:
                                                            scope.row
                                                              .rate_price,
                                                          size: "mini",
                                                        },
                                                        on: {
                                                          input: (val) =>
                                                            _vm.updateField(
                                                              scope.$index,
                                                              "rate_price",
                                                              val
                                                            ),
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              1916307826
                                            ),
                                          }),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "rate_weight",
                                              label: "计费重量(kg)",
                                              "min-width": "110",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("el-input", {
                                                        attrs: { size: "mini" },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .rate_weight,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "rate_weight",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.rate_weight",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              3822951960
                                            ),
                                          }),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "weight",
                                              label: "包裹重量(kg)",
                                              "min-width": "110",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("el-input", {
                                                        attrs: { size: "mini" },
                                                        model: {
                                                          value:
                                                            scope.row.weight,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "weight",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.weight",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              3680720069
                                            ),
                                          }),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "length",
                                              label: "长(cm)",
                                              width: "100",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("el-input", {
                                                        attrs: { size: "mini" },
                                                        model: {
                                                          value:
                                                            scope.row.length,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "length",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.length",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              3712716953
                                            ),
                                          }),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "width",
                                              label: "宽(cm)",
                                              width: "100",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("el-input", {
                                                        attrs: { size: "mini" },
                                                        model: {
                                                          value:
                                                            scope.row.width,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "width",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.width",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              600652707
                                            ),
                                          }),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "height",
                                              label: "高(cm)",
                                              width: "100",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("el-input", {
                                                        attrs: { size: "mini" },
                                                        model: {
                                                          value:
                                                            scope.row.height,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "height",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.height",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              2236028506
                                            ),
                                          }),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: "操作",
                                              width: "100",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "loading",
                                                              rawName:
                                                                "v-loading",
                                                              value:
                                                                _vm.isLoading,
                                                              expression:
                                                                "isLoading",
                                                            },
                                                          ],
                                                          attrs: {
                                                            size: "mini",
                                                            type: "primary",
                                                            disabled:
                                                              _vm.isLoading,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.saveRow(
                                                                scope.row
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.isLoading
                                                                  ? "修改中"
                                                                  : "保存"
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              401513971
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }